import { Link } from "react-router-dom";
import { Check, Clock, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { rupiah } from "@/lib/format";

export const sessionsLabel = (s) => {
  const v = String(s ?? "").trim();
  if (!v || v === "0") return "";
  return /^\d+$/.test(v) ? `${v} pertemuan` : v;
};

export default function PackageCard({ pkg, compact = false }) {
  const dark = pkg.highlight;
  return (
    <div
      className={`relative flex flex-col rounded-lg border p-6 transition-transform duration-300 hover:-translate-y-1 ${dark ? "bg-slate-900 text-white border-slate-900" : "bg-white border-slate-200 hover:border-amber-400"}`}
      data-testid={`package-card-${pkg.code}`}
    >
      {dark && <span className="absolute -top-3 left-6 bg-amber-500 text-slate-900 text-[10px] font-bold uppercase tracking-widest px-2.5 py-1 rounded">Unggulan</span>}
      <span className={`text-[11px] font-semibold uppercase tracking-[0.2em] ${dark ? "text-amber-400" : "text-amber-600"}`}>{pkg.category}</span>
      <h3 className="font-display text-xl font-bold mt-2">{pkg.name}</h3>
      {!compact && <p className={`text-sm mt-2 leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"}`}>{pkg.description}</p>}
      <p className="font-display text-2xl font-extrabold mt-5" data-testid={`package-price-${pkg.code}`}>{rupiah(pkg.price)}</p>
      <div className={`flex gap-4 text-xs mt-2 ${dark ? "text-slate-400" : "text-slate-500"}`}>
        <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5" />{pkg.duration_days} hari</span>
        {sessionsLabel(pkg.sessions) && <span className="flex items-center gap-1" data-testid={`package-sessions-${pkg.code}`}><Users className="h-3.5 w-3.5" />{sessionsLabel(pkg.sessions)}</span>}
      </div>
      {!compact && (
        <ul className="mt-5 space-y-2 text-sm flex-1">
          {pkg.features?.map((f) => (
            <li key={f} className="flex gap-2"><Check className="h-4 w-4 mt-0.5 text-amber-500 shrink-0" />{f}</li>
          ))}
        </ul>
      )}
      <Button asChild className={`mt-6 ${dark ? "bg-amber-500 text-slate-900 hover:bg-amber-400" : "bg-slate-900 hover:bg-slate-800"}`} data-testid={`package-select-${pkg.code}`}>
        <Link to={`/daftar?paket=${pkg.id}`}>Pilih Paket</Link>
      </Button>
    </div>
  );
}
